import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UtsavModal from "src/globalModule/components/UtsavModal";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import classes from "../../../styles/navbar.module.css";
import { appBaseUrl } from "@utils/BASE-URL";
import { deleteRegistrationDetails } from "@utils/reduxToolkit/features/registrationDetailsSlice";
import { deleteCart } from "@utils/reduxToolkit/features/cartSlice";
function Navbar({
  name,
  activeStep,
  setActiveStep,
  closeModal
}) {
  const dispatch = useDispatch();
  const router = useRouter();
  const {
    t
  } = useTranslation();
  const {
    eventid
  } = router.query;
  const [openBackModal, setOpenBackModal] = useState(false);
  const toggleModal = () => {
    setOpenBackModal(cur => !cur);
  };
  const redirecting = () => {
    if (closeModal) {
      closeModal();
      return;
    }
    let redirectUrl = `${appBaseUrl}/puja`;
    if (activeStep === 4) {
      setActiveStep(3);
    } else {
      window.location.href = redirectUrl;
      dispatch(deleteRegistrationDetails());
      dispatch(deleteCart());
    }
  };
  return <>
      <div className={classes.navHead}>
        <Stack direction="row" alignItems={"center"} gap={"10px"} data-sentry-element="Stack" data-sentry-source-file="navbar.jsx">
          <ArrowBackIcon sx={{
          width: "24px",
          height: "24px",
          ml: "0px"
        }} onClick={() => activeStep === 4 ? redirecting() : toggleModal()} data-sentry-element="ArrowBackIcon" data-sentry-source-file="navbar.jsx" />
          <Typography className={classes.templeName} data-sentry-element="Typography" data-sentry-source-file="navbar.jsx">{name}</Typography>
        </Stack>

        {/* <LangugageDropdown /> */}
      </div>
      {openBackModal && <UtsavModal open={openBackModal} toggleModal={toggleModal} heading={t("your-registration-would-not-be-saved")} message={t("are-you-sure")} acceptMsg={t("sure")} onAccept={redirecting} rejectMsg={t("cancel")} positive={false} />}
    </>;
}
export default Navbar;